import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { App } from './routes/App'

ReactDOM.render(<App />, document.getElementById('root'))
